export const COMPONENT_TYPE = {
  list: 'i4pro-list',
  form: 'i4pro-form',
  subPages: 'i4pro-sub-pages',
  new: 'i4pro-form',
  search: 'i4pro-form',
  sidebar: 'i4pro-form'
};

Object.freeze(COMPONENT_TYPE);
